import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/** Tailwind-aware class merger used by every component. */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
